import {defineMessages} from 'react-intl'
import async from 'async'
import R from 'ramda'

import {toApi} from '../utils/apiMapper' 
import getCurrentQuery from '../utils/getCurrentQuery'

import {mapSearch} from '../api/search'

import addNotification from './addNotification'

const messages = defineMessages({
  title: {
    id: 'An error occured', 
    defaultMessage: 'An error occured'
  },
  message: {
    id: "The search for estate on the map could be be completed", 
    defaultMessage: "The search for estate on the map could be be completed"
  }
})

const notification = {type: "error", message: messages.message, title: messages.title}

const onComplete = dispatch => (err, estates) => {
  if(err) { 
    dispatch(addNotification(notification))
    return console.error("Failed to execute mapSearch", err) 
  }
  dispatch({type: 'load_estate_map', estates})
}

export default _ => (dispatch, getState) => {
  const query = getCurrentQuery()
  const apiQuery = toApi(query, getState())

  mapSearch(apiQuery, onComplete(dispatch))
}



/** WEBPACK FOOTER **
 ** ./app/actions/mapSearch.js
 **/